<template>
  <v-container fluid fill-height>
    <v-layout align-start justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Resetowanie hasła</v-toolbar-title>
          </v-toolbar>
          <form class="login" @submit.prevent="passwordReset" novalidate>
          <v-card-text>
            <v-alert
              :value="validation.hasError('userCredentials.non_field_errors')"
              type="error"
            >
              <span v-for="error in validation.allErrors('userCredentials.non_field_errors')">{{error}}</span>
            </v-alert>
              <v-text-field
                prepend-icon="person"
                v-model="userCredentials.email"
                :error-messages="validation.allErrors('userCredentials.email')"
                name="login"
                label="E-mail"
                type="text"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="primary">Wyślij przypomnienie</v-btn>
          </v-card-actions>
          </form>
          <v-progress-linear v-if="progress" :indeterminate="true"></v-progress-linear>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {Validator} from 'simple-vue-validator'
import iziToast from 'izitoast'
import {passwordReset} from './api'

export default {
  validators: {
    'userCredentials.email': function (value) {
      return Validator.value(value).required().email()
    }
  },
  data () {
    return {
      userCredentials: {
        email: ''
      },
      progress: false,
      errors: []
    }
  },
  methods: {
    passwordReset: function () {
      this.$validate().then(success => {
        if (success) {
          passwordReset(this.userCredentials.email).then((data) => {
            iziToast.show({
              message: 'Na wskazany adres e-mail zostało wysłane przypomnienie hasła',
              color: 'green'
            })
            this.$router.push({name: 'app'})
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/PasswordReset.vue